export default __webpack_public_path__ + "static/media/dumyImg.7978b43a.png";